import { Box, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import { IoHeartDislike } from "react-icons/io5";
import { useTranslation } from "react-i18next";

function NoLikesMessage() {
  const { t } = useTranslation();
  const cardBg = useColorModeValue("rgba(255,255,255,0.7)", "rgba(255,255,255,0.04)");
  const border = useColorModeValue("gray.200", "whiteAlpha.100");
  const title = useColorModeValue("gray.800", "white");
  const desc = useColorModeValue("gray.600", "whiteAlpha.600");
  const iconBg = useColorModeValue("brand.50", "whiteAlpha.100");

  return (
    <Box
      w="100%"
      py={8}
      px={4}
      borderRadius="xl"
      border="1px dashed"
      borderColor={border}
      bg={cardBg}
      textAlign="center"
      mb={3}
    >
      <Box
        mx="auto"
        mb={3}
        w={12}
        h={12}
        borderRadius="full"
        bg={iconBg}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon as={IoHeartDislike} boxSize={6} color="brand.500" />
      </Box>
      <Text fontWeight="semibold" color={title} fontSize="sm" mb={1}>
        {t("likes.noLikesYet")}
      </Text>
      <Text fontSize="xs" color={desc} lineHeight="tall" maxW="240px" mx="auto">
        {t("likes.noLikesHint")}
      </Text>
    </Box>
  );
}

export default NoLikesMessage;
